module.exports = __webpack_public_path__ + "img/check_true.87ea2d43.svg";